const FETCH_BANKS_REQUEST = "FETCH_BANKS_REQUEST";
const FETCH_BANKS_SUCCESS = "FETCH_BANKS_SUCCESS";
const FETCH_BANKS_FAILURE = "FETCH_BANKS_FAILURE";

export default {
  FETCH_BANKS_REQUEST,
  FETCH_BANKS_SUCCESS,
  FETCH_BANKS_FAILURE,
};
